/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFilePageBlock } from './DatabaseFilePageBlock';
import {
    DatabaseFilePageBlockFromJSON,
    DatabaseFilePageBlockFromJSONTyped,
    DatabaseFilePageBlockToJSON,
} from './DatabaseFilePageBlock';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseVideoPageBlock
 */
export interface DatabaseVideoPageBlock extends DatabaseFilePageBlock {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseVideoPageBlock
     */
    loop?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVideoPageBlock
     */
    objectFit?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVideoPageBlock
     */
    objectPosition?: string;
}

/**
 * Check if a given object implements the DatabaseVideoPageBlock interface.
 */
export function instanceOfDatabaseVideoPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseVideoPageBlockFromJSON(json: any): DatabaseVideoPageBlock {
    return DatabaseVideoPageBlockFromJSONTyped(json, false);
}

export function DatabaseVideoPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseVideoPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFilePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'loop': !exists(json, 'loop') ? undefined : json['loop'],
        'objectFit': !exists(json, 'objectFit') ? undefined : json['objectFit'],
        'objectPosition': !exists(json, 'objectPosition') ? undefined : json['objectPosition'],
    };
}

export function DatabaseVideoPageBlockToJSON(value?: DatabaseVideoPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFilePageBlockToJSON(value),
        'loop': value.loop,
        'objectFit': value.objectFit,
        'objectPosition': value.objectPosition,
    };
}

